import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getEngineerToken } from '../../services/engineerService';

const EngineerRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  if (!getEngineerToken()) {
    return <Navigate to="/engineer/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
};

export default EngineerRoute;
